module.exports = __webpack_public_path__ + "img/o2o01.937b76a6.png";